import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
} from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import SendMoneyService from "../../../services/send-money.service";
import { NumericFormat } from "react-number-format";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";
import {
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  allowDecimalwithMaxLimit,
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyAlphabetsWithSpace,
  allowOnlyNumbers,
  amountFormat,
} from "../../../services/common.service";
import { useDispatch, useSelector } from "react-redux";
import {
  accountListSelector,
  modeSelector,
  selectedAccountSelector,
} from "../../../store/selectors/app.selector";
import TransferService from "../../../services/transfer.service";
import CommonOtp from "../../../components/otp";
import {
  setAccountList,
  setSelectedAccount,
} from "../../../store/actions/app.action";
import AccountService from "../../../services/accounts.service";
import successIcon from "../../../assests/images/success.png";
import dayjs from "dayjs";
import AccountDisplay from "../../../components/account-display";
import { CONFIG } from "../../../environment";
import checkedIcon from "../../../assests/images/checked.svg";
import unCheckedIcon from "../../../assests/icons/uncheck.png";
import { ReactComponent as TitleIcon } from "../../../assests/images/quicktbreadrans.svg";
import AccountCard from "../../../components/account-card";
import AccountSelectedCard from "../../../components/account-selected-card";
import { ReactComponent as TickIcon } from "../../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import AccountDisplayView from "../../../components/account-display-view";
import PendingAuthService from "../../../services/approvals.service";

const financialServiceProviders = [
  {
    code: null,
    fspCode: "501",
    fspName: "MIC Tanzania PLC - (TIGO PESA)",
    fspType: "MSISDN",
    displayName: "TIGO-ZANTEL",
  },
  {
    code: null,
    fspCode: "502",
    fspName: "Zanzibar Telecom PLC - (EZY - PESA)",
    fspType: "MSISDN",
    displayName: "EZY-PESA",
  },
  {
    code: null,
    fspCode: "503",
    fspName: "Vodacom Tanzania PLC - (MPESA)",
    fspType: "MSISDN",
    displayName: "MPESA",
  },
  {
    code: null,
    fspCode: "504",
    fspName: "Airtel Tanzania PLC (AIRTEL MONEY)",
    fspType: "MSISDN",
    displayName: "AIRTEL MONEY",
  },
  {
    code: null,
    fspCode: "505",
    fspName: "Tanzania Telecommunications Corporation - (T-PESA)",
    fspType: "MSISDN",
    displayName: "T-PESA",
  },
  {
    code: null,
    fspCode: "506",
    fspName: "Viettel Tanzania PLC - (HALOPESA)",
    fspType: "MSISDN",
    displayName: "HALOPESA",
  },
  {
    code: null,
    fspCode: "511",
    fspName: "Azam Pesa",
    fspType: "MSISDN",
    displayName: "Azam Pesa",
  },
];
export default function WalletQuickTransfer() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [verifyDetails, setVerifyDetails] = useState({});
  const [form] = Form.useForm();
  const accountList = useSelector(accountListSelector);
  const [formDetails, setFormDetails] = useState({
    addBene: false,
    hasFxDeal: false,
    paymentType: "ONCE",
    paymentSubType: "Pay_Now",
    txnCcy: "",
  });
  const [cancelVisible, setCancelVisible] = useState(false);
  const [respDetails, setRespDetails] = useState({});
  const dispatch = useDispatch();
  const mode = useSelector(modeSelector);
  const [metaData, setMetaData] = useState({
    frequency: [],
    maximumInstallments: [],
    paymentTypes: {},
    transferTypes: {},
  });
  const selectedAccount = useSelector(selectedAccountSelector);
  const [addBene, setAddBene] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const [selectedFspBank, setSelectedFspBank] = useState({});
  const [convertedAmount, setConvertedAmount] = useState({});
  const [hasFxDeal, setHasFxDeal] = useState(false);
  const [selectedTxnCcy, setSelectedTxnCcy] = useState();
  const [txnCurrencyList, setTxnCurrencyList] = useState([]);
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const { t } = useTranslation();
  const [paymentType, setPaymentType] = useState("ONCE");
  const [paymentSubType, setPaymentSubType] = useState("Pay_Now");
  const [mobileLookup, setMobileLookup] = useState(false);

  useEffect(() => {
    if (accountList?.length > 0) {
      setConvertedAmount({});
      form.resetFields(["amount"]);
      setTxnCurrencyList([CONFIG.CURRENCY]);
      form.setFieldsValue({ txnCcy: CONFIG.CURRENCY });
    }
  }, [accountList, selectedAccount]);

  useEffect(() => {
    transferOptions();
  }, []);

  const transferOptions = useCallback(async () => {
    try {
      const response = await SendMoneyService.transferOptions();
      if (response.status === 200) {
        setMetaData(response.data["data"]);
        let mobile = response.data["data"]["mobileNo"];

        // identifyNetworkOperator(mobile);
        // form.setFieldsValue({ walletMobileNo: mobile });
        // if (mobile) {
        //   setMobileLookup(true);
        // }
      }
    } catch (error) {}
  }, []);

  // useEffect(() => {
  //   if (mobileLookup && selectedFspBank.fspName) {
  //     accountLookUp(metaData["mobileNo"]);
  //   }
  // }, [mobileLookup, selectedFspBank, metaData]);

  const onVerify = useCallback(
    async (values) => {
      try {
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );

        const transferAmount =
          typeof values.amount === "number"
            ? values.amount
            : parseFloat(values.amount.replaceAll(/,/g, ""));

        const fxdealrates = values?.fxDealRefNo
          ? {
              fxreferencerate: convertedAmount?.convRate || "",
              isfxDealRateAvl: "Y",
            }
          : { fxreferencerate: "", isfxDealRateAvl: "N" };

        const reqParams = {
          srcAcct: srcAccDetails?.accountNo,
          accountName: srcAccDetails?.accountName,
          srcAccName: srcAccDetails?.accountName,
          srcBr: srcAccDetails?.branchId,
          srcCcy: srcAccDetails?.accountCurrency,
          destBr:
            accountDetails?.accBranch ||
            selectedFspBank?.fspCode ||
            CONFIG.BRANCH_NAME,
          destCcy: CONFIG.CURRENCY,
          destAcct: values?.walletMobileNo,
          amount: transferAmount,
          narration: values?.remarks || "",
          remarks: values?.remarks || "",
          remarksTag: values?.remarks,
          txnType: "TIPS",
          quickTransfer: true,
          destBankName: selectedFspBank?.fspName,
          destBankAddr: "",
          destBankCty: "",
          txnCcy: values?.txnCcy,
          txnDate: dayjs(new Date()),
          chargeBornesBy: "OUR",
          beneName: accountDetails?.customerName || values?.beneName,
          beneMobileNo: values?.walletMobileNo,
          beneMail: "",
          beneAddr: "",
          fxDealRefNo: values?.fxDealRefNo || "",
          bicCode: selectedFspBank?.fspCode,
          sortCode: "",
          swiftCode: "",
          custId: srcAccDetails?.customerId,
          paymentType:
            paymentType === "ONCE" && paymentSubType === "Pay_Later"
              ? "SCHEDULED"
              : paymentType,
          numberOfInstallments: values?.numberOfInstallment,
          customFields: {
            DISPLAY: "MPESA",
            IDENTIFIER: selectedFspBank?.fspType,
            payerIdnfrType: selectedFspBank?.fspType,
            payeeIdnfrType: selectedFspBank?.fspType,
            payerAccCategory: "BUSINESS",
            payerAccType: "BANK",
            payeeAccCategory: "PERSON",
            payeeAccType: "WALLET",
            payerName: srcAccDetails?.accountName,
            FSPCODE: selectedFspBank?.fspCode,
            ...fxdealrates,
          },
          payeeId: 0,
          scheduled:
            paymentType === "ONCE" && paymentSubType === "Pay_Later"
              ? true
              : false,
          addBene: addBene,
          recurring: paymentType === "RECURRING",
          scheduledDate: values?.frequencyDate,
          frequency: values?.frequency,
          bulkTransfer: false,
        };
        setFormDetails(reqParams);
        setStage(2);
      } catch (error) {}
    },
    [
      accountList,
      metaData,
      accountDetails,
      selectedAccount,
      selectedFspBank,
      addBene,
      paymentSubType,
      paymentType,
      convertedAmount,
    ]
  );

  const fundTransferVerify = useCallback(async () => {
    try {
      const req = {
        ...formDetails,
        conversionAmount: convertedAmount?.convAmt || "",
        conversionRate: convertedAmount.convRate || "",
      };
      setFormDetails(req);
      const response = await TransferService.fundTransferVerify(formDetails);
      if (response.status === 200) {
        setVerifyDetails(response.data["data"]);

        if (response.data["data"]["otpEnabled"]) {
          setStage(3);
        } else {
          fundTransferConfirm({
            ...req,
            ...{ otp: CONFIG.DEFAULT_OTP },
          });
        }
      }
    } catch (error) {}
  }, [formDetails, convertedAmount]);

  const fundTransferConfirm = useCallback(async (reqParams) => {
    try {
      setFormDetails(reqParams);
      const response = await TransferService.fundTransferConfirm(reqParams);
      if (response.status === 200) {
        dispatch(setAccountList([]));
        setRespDetails({
          message: response.data?.message,
          ...response.data["data"],
        });
        await fetchAccounts();
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
      if (["TG-USR-40025", "TG-USR-40026"].indexOf(error.data.code) < 0) {
        setStage(1);
      }
    }
  }, []);

  const fetchAccounts = useCallback(async () => {
    try {
      const response = await AccountService.getQuickAccounts("BA");
      if (response.status === 200) {
        const selectedAccountDetails =
          response?.data["data"]["accounts"].find(
            (ele) => ele.primaryAccount === true
          ) ||
          response.data["data"]["accounts"][0] ||
          [];
        dispatch(setSelectedAccount(selectedAccountDetails));
      }
    } catch (error) {}
  }, []);

  function identifyNetworkOperator(mobileNumber) {
    const prefix = mobileNumber.substring(0, 2);
    const azamPrefix = mobileNumber.substring(0, 1);
    let selectedFspBank;

    if (prefix === "74" || prefix === "75" || prefix === "76") {
      selectedFspBank = financialServiceProviders[2]; // Vodacom Tanzania
    } else if (prefix === "68" || prefix === "69" || prefix === "78") {
      selectedFspBank = financialServiceProviders[3]; // Airtel Tanzania
    } else if (prefix === "73") {
      selectedFspBank = financialServiceProviders[4]; // Tigo Tanzania
    } else if (prefix === "61" || prefix === "62") {
      selectedFspBank = financialServiceProviders[5]; // Halotel
    } else if (azamPrefix === "1") {
      selectedFspBank = financialServiceProviders[6]; // Azam Pesa
    } else if (
      prefix === "77" ||
      prefix === "71" ||
      prefix === "80" ||
      prefix === "67" ||
      prefix === "65"
    ) {
      selectedFspBank = financialServiceProviders[0]; // Tigo
    } else {
      return false;
    }
    setSelectedFspBank(selectedFspBank);
    return selectedFspBank;
  }

  const accountLookUp = useCallback(
    async (acctNo) => {
      try {
        if (+acctNo.length === CONFIG?.WALLET_MOBILE_LENGTH) {
          const reqParams = {
            transferType: "TIPS",
            accountNo: "",
            mobileNo: acctNo,
            bankName: selectedFspBank.fspName,
            custParams: {
              IDENTIFIER: "MSISDN",
              FSPCODE: selectedFspBank?.fspCode,
            },
          };
          const response = await SendMoneyService.accountLookUp(reqParams);
          if (response.status === 200) {
            // setMobileLookup(false);
            setAccountDetails(response.data);
            form.setFieldsValue({
              beneName: response.data?.customerName || undefined,
            });

            setTxnCurrencyList([
              response.data?.accCcy,
              selectedAccount?.accountCurrency,
            ]);
          }
        }
      } catch (error) {
        setAccountDetails({});
      }
    },
    [selectedFspBank, selectedAccount]
  );

  const getConvertedAmount = useCallback(async () => {
    try {
      if (CONFIG?.CROSS_CURRENCY === false) {
        return;
      }
      const { transferType, amount, txnCcy, fxDealRefNo } =
        form.getFieldsValue();
      setSelectedTxnCcy(txnCcy);
      const transferAmount =
        typeof amount === "number"
          ? amount
          : parseFloat(amount.replaceAll(/,/g, ""));
      const reqParams = {
        srcCcy: selectedAccount?.accountCurrency,
        destCcy: accountDetails?.accCcy || CONFIG.CURRENCY,
        txnCcy: txnCcy,
        txnType: transferType,
        amount: transferAmount,
        fxDealRefNo: fxDealRefNo,
        srcAcct: selectedAccount?.accountNo,
        accountName: selectedAccount?.accountName,
        srcAccName: selectedAccount?.accountName,
      };
      if (txnCcy === selectedAccount?.accountCurrency) {
        return;
      }
      const response = await TransferService.getConvertedAmount(reqParams);
      if (response.status === 200) {
        setConvertedAmount(response.data["data"]);
      }
    } catch (error) {}
  }, [selectedAccount, accountDetails]);

  const handleDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        txnId: selected?.txnId,
      };
      setSuccessVisible(false);

      await PendingAuthService.downloadReceipts(reqParams);
      navigate("/transfer");
    } catch (err) {}
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) =>
              fundTransferConfirm({ ...formDetails, ...values })
            }
            handleResendOtp={() => fundTransferVerify()}
            cancelTransaction={() => {
              navigate("/transfer");
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          {/* <p className="mb-4">Please fill required details, before you proceed</p> */}
          <p>
            {t("pages.fundtransfer.transfer_desc", {
              defaultValue: "Please enter below details",
            })}
          </p>
          <div className="row">
            <div className="d-flex align-items-center">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <AccountDisplay type="image" currencyFilter={true} />
              </div>
            </div>
          </div>
          <Form
            layout="vertical"
            requiredMark={true}
            form={form}
            onFinish={onVerify}
            initialValues={formDetails}
          >
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  name="walletMobileNo"
                  label={t("pages.Add_Bene.wallet_mob_no", {
                    defaultValue: "Wallet Mobile Number",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.wallet_mobile_requir", {
                        defaultValue: "Wallet Mobile Number is required",
                      }),
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (
                          !value ||
                          getFieldValue("walletMobileNo")?.length ===
                            CONFIG?.WALLET_MOBILE_LENGTH
                        ) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          t("errorMesssages.wallet_mobile_valid", {
                            defaultValue:
                              "Wallet Mobile Number should be 9 digits",
                          })
                        );
                      },
                    }),
                  ]}
                >
                  <NumericFormat
                    maxLength={CONFIG?.WALLET_MOBILE_LENGTH}
                    placeholder={t("pages.Add_Bene.wallet_mob_no", {
                      defaultValue: "Wallet Mobile Number",
                    })}
                    allowNegative={false}
                    customInput={Input}
                    size="large"
                    allowLeadingZeros={true}
                    addonBefore={CONFIG?.DEFAULT_MOBILE_PREFIX || ""}
                    onChange={(e) => {
                      identifyNetworkOperator(e.target.value);
                    }}
                    onBlur={(e) => {
                      accountLookUp(e.target.value);
                    }}
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.Add_Bene.bane_name", {
                    defaultValue: "Beneficiary Name",
                  })}
                  name={"beneName"}
                  rules={[
                    {
                      required: true,
                      message: t("pages.Add_Bene.bene_name_req", {
                        defaultValue: "Beneficiary Name is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    onKeyPress={(e) =>
                      allowOnlyAlphaNumericsShouldNotStartWithSpace(e)
                    }
                    maxLength={CONFIG.BENE_NICKNAME_LENGTH}
                    placeholder={t("pages.Add_Bene.bane_name", {
                      defaultValue: "Beneficiary Name",
                    })}
                    size="large"
                  />
                </Form.Item>
              </div>
              <div
                className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                style={{ position: "relative" }}
              >
                <Form.Item
                  label={t("pages.fundtransfer.transaction_curr", {
                    defaultValue: "Transaction Currency",
                  })}
                  name={"txnCcy"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.trans_currency_require", {
                        defaultValue: "Transaction Currency is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("pages.fundtransfer.transaction_curr", {
                      defaultValue: "Transaction Currency",
                    })}
                    bordered={true}
                    size="large"
                    optionFilterProp="children"
                    showSearch
                    onChange={(e) => {
                      form.setFieldsValue({ amount: "" });
                      setConvertedAmount({});
                    }}
                  >
                    {txnCurrencyList.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("common.amount", {
                    defaultValue: "Amount",
                  })}
                  name={"amount"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.amount_required", {
                        defaultValue: "Amount is required",
                      }),
                    },
                    {
                      validator: (_, value) => {
                        if (parseFloat(value) <= 0) {
                          return Promise.reject(
                            t("errorMesssages.amount_valid", {
                              defaultValue: "Amount should be greater than 0",
                            })
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <NumericFormat
                    type="tel"
                    placeholder={t("common.amount", {
                      defaultValue: "Amount",
                    })}
                    maxLength={12}
                    allowNegative={false}
                    customInput={Input}
                    thousandSeparator={true}
                    fixedDecimalScale={false}
                    onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                    onBlur={(e) => {
                      e.target.value.length > 0 && getConvertedAmount();
                    }}
                    onChange={() => setConvertedAmount({})}
                    size="large"
                  />
                </Form.Item>

                {Object.keys(convertedAmount).length !== 0 && (
                  <div className="row mb-2">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <label className="mb-1">
                        {convertedAmount?.prefferedRate === true
                          ? t(
                              "pages.sendMoney.common_sendMoney.preffered_rate",
                              {
                                defaultValue: "Preffered Rate",
                              }
                            )
                          : t(
                              "pages.sendMoney.common_sendMoney.exchange_rate",
                              {
                                defaultValue: "Exchange Rate",
                              }
                            )}
                      </label>{" "}
                      <br />
                      <span>
                        1 {selectedAccount?.accountCurrency} ={" "}
                        {selectedTxnCcy + " " + convertedAmount.convRate}
                      </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <label className="mb-1">
                        {" "}
                        {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                          defaultValue: "Deducted Amount",
                        })}
                      </label>
                      <br />
                      <span>{convertedAmount.deductedAmt}</span>
                    </div>
                  </div>
                )}
              </div>

              {CONFIG?.PAYMENT_OPTION && (
                <>
                  <span
                    className="d-block mb-3 "
                    style={{ textAlign: "left", cursor: "pointer" }}
                  >
                    {t("pages.fundtransfer.payment_options", {
                      defaultValue: "Payment Options",
                    })}
                  </span>

                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
                      <Form.Item
                        label=""
                        name={"paymentType"}
                        style={
                          paymentType === "RECURRING"
                            ? { marginBottom: 20 }
                            : { marginBottom: 5 }
                        }
                      >
                        <Radio.Group
                          onChange={(e) => setPaymentType(e.target.value)}
                        >
                          <Radio value={"ONCE"}>
                            {t("pages.fundtransfer.one_time", {
                              defaultValue: "One Time",
                            })}
                          </Radio>
                          <Radio value={"RECURRING"}>
                            {t("pages.fundtransfer.recurring", {
                              defaultValue: "Recurring",
                            })}
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                      {paymentType === "ONCE" && (
                        <Form.Item label="" name={"paymentSubType"}>
                          <Radio.Group
                            onChange={(e) => setPaymentSubType(e.target.value)}
                          >
                            <Radio value={"Pay_Now"}>
                              {t("pages.fundtransfer.pay_now", {
                                defaultValue: "Pay Now",
                              })}
                            </Radio>
                            <Radio value={"Pay_Later"}>
                              {t("pages.fundtransfer.pay_later", {
                                defaultValue: "Pay Later",
                              })}
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      )}
                    </div>
                  </div>
                </>
              )}

              {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Form.Item
                    label={t("pages.sendMoney.common_sendMoney.date", {
                      defaultValue: "Date",
                    })}
                    name={"frequencyDate"}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.date_require", {
                          defaultValue: "Date is required",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      // inputReadOnly={true}
                      allowClear={false}
                      showToday={false}
                      disabledDate={(current) => {
                        return (
                          dayjs().add(0, "days") >= current ||
                          dayjs().add(6, "month") <= current
                        );
                      }}
                      placeholder="DD-MM-YYYY"
                      // format={"DD-MM-YYYY"}
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      size="large"
                    />
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.fundtransfer.no_of_instal", {
                      defaultValue: "Number of installment",
                    })}
                    name={"numberOfInstallment"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.no_insdtall_require", {
                          defaultValue: "Number of installment is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("pages.fundtransfer.no_of_instal", {
                        defaultValue: "Number of installment",
                      })}
                      bordered={true}
                      size="large"
                    >
                      {metaData.maximumInstallments.map((option, idx) => (
                        <Select.Option key={idx} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.fundtransfer.frequency", {
                      defaultValue: "Frequency",
                    })}
                    name={"frequency"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.freq_requir", {
                          defaultValue: "Frequency is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("pages.fundtransfer.frequency", {
                        defaultValue: "Frequency",
                      })}
                      bordered={true}
                      size="large"
                    >
                      {metaData.frequency.map((option, idx) => (
                        <Select.Option key={idx} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.common.start_date", {
                      defaultValue: "Start Date",
                    })}
                    name={"frequencyDate"}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.start_date_require", {
                          defaultValue: "Start Date is required",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      // inputReadOnly={true}
                      allowClear={false}
                      showToday={false}
                      disabledDate={(current) => {
                        return (
                          dayjs().add(0, "days") >= current ||
                          dayjs().add(1, "month") <= current
                        );
                      }}
                      placeholder="DD-MM-YYYY"
                      // format={"DD-MM-YYYY"}
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      size="large"
                    />
                  </Form.Item>
                </div>
              )}

              {form?.getFieldValue("txnCcy") !==
                selectedAccount?.accountCurrency && (
                <Form.Item
                  label={""}
                  name={"hasFxDeal"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.has_fx_deal_require", {
                        defaultValue: "Has Fx Deal is required",
                      }),
                    },
                  ]}
                >
                  <span style={{ marginRight: "10px" }}>
                    <span className="asterisk-mark">*</span>
                    {t("pages.fundtransfer.hasfx", {
                      defaultValue: "Has Fx Deal ?",
                    })}
                  </span>
                  <Radio.Group
                    onChange={(e) => setHasFxDeal(e.target.value)}
                    value={hasFxDeal}
                  >
                    <Radio value={true}>
                      {t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })}
                    </Radio>
                    <Radio value={false}>
                      {t("buttons.no_btn", {
                        defaultValue: "No",
                      })}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              )}
              {hasFxDeal && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Form.Item
                    label={t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                    name={"fxDealRefNo"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.fx_ref_num_require", {
                          defaultValue: "Fx Ref Number is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                      maxLength={30}
                      placeholder={t("pages.fundtransfer.fxno", {
                        defaultValue: "Fx Ref Number",
                      })}
                      size="large"
                      onBlur={(e) => {
                        e.target.value.length > 0 && getConvertedAmount();
                      }}
                    />
                  </Form.Item>
                </div>
              )}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  name="remarks"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.remark_require", {
                        defaultValue: "Reason is required",
                      }),
                    },
                  ]}
                  label={t("common.remarks", {
                    defaultValue: "Reason",
                  })}
                >
                  <Input
                    placeholder={t("common.remarks", {
                      defaultValue: "Reason",
                    })}
                    size="large"
                    onKeyPress={(e) =>
                      allowOnlyAlphaNumericsShouldNotStartWithSpace(e)
                    }
                    maxLength={30}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="bene-btn-group-container  mt-3">
              <div onClick={() => setAddBene(!addBene)} className="mt-1">
                {accountDetails?.beneExists !== true && (
                  <>
                    {" "}
                    <span style={{ marginRight: "5px ", cursor: "pointer" }}>
                      {addBene ? (
                        <img
                          src={checkedIcon}
                          alt="checked"
                          width={17}
                          height={17}
                          className="checked"
                        />
                      ) : (
                        <img
                          src={unCheckedIcon}
                          alt="unchecked"
                          width={17}
                          height={17}
                          className="unchecked"
                        />
                      )}
                    </span>
                    {t("pages.Add_Bene.title", {
                      defaultValue: "Add Beneficiary",
                    })}
                  </>
                )}
              </div>
              <div className="btn-group-container-style">
                <Button
                  onClick={() => navigate("/send-money")}
                  type="default"
                  className="secondary-btn"
                  style={{ marginRight: 20 }}
                  size="large"
                >
                  {t("buttons.cancel_btn", {
                    defaultValue: "Cancel",
                  })}
                </Button>

                <Button
                  type="primary"
                  className="primary-btn"
                  htmlType="submit"
                  // disabled={Object.keys(accountDetails).length === 0}
                  size="large"
                >
                  {t("buttons.submit_btn", {
                    defaultValue: "Submit",
                  })}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>

        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.sendMoney.payee.payment_txt", {
            defaultValue:
              "Please check the payment details carefully, before you proceed",
          })}
        </p>

        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <AccountDisplayView />
            </div>
          </div>
        </div>

        <div className="confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.wallet_mob_no", {
                  defaultValue: "Wallet Mobile Number",
                })}
              </label>
              <span>{formDetails?.destAcct}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.pay_bills.mobile_operator_name", {
                  defaultValue: "Mobile Operator Name",
                })}{" "}
              </label>
              <span>{formDetails?.destBankName}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bane_name", {
                  defaultValue: "Beneficiary Name",
                })}
              </label>
              <span>{formDetails?.beneName || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.transfer_type", {
                  defaultValue: "Transfer Type",
                })}
              </label>
              <span>{formDetails?.txnType}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.mode_transfer", {
                  defaultValue: "Mode of Transfer",
                })}
              </label>

              <span>
                {t("pages.Add_Bene.wallet", {
                  defaultValue: "Wallet",
                })}
              </span>
            </div>

            {accountDetails?.beneExists !== true && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.Add_Bene.title", {
                    defaultValue: "Add Beneficiary",
                  })}
                </label>
                <span>
                  {formDetails?.addBene
                    ? t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })
                    : t("buttons.no_btn", {
                        defaultValue: "No",
                      })}
                </span>
              </div>
            )}
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.fundtransfer.transaction_curr", {
                  defaultValue: "Transaction Currency",
                })}
              </label>
              <span>{formDetails?.txnCcy}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.payee.network_operator", {
                  defaultValue: "Network Operator",
                })}
              </label>
              <span>{selectedFspBank?.displayName}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.amount", {
                  defaultValue: "Amount",
                })}
              </label>
              <span>{amountFormat(formDetails?.amount, selectedTxnCcy)}</span>
            </div>

            {Object.keys(convertedAmount).length !== 0 ? (
              <>
                <div className="confirm-label-wrapper">
                  <label>
                    {" "}
                    {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                      defaultValue: "Deducted Amount",
                    })}
                  </label>
                  <span>{convertedAmount.deductedAmt}</span>
                </div>
              </>
            ) : null}

            {CONFIG?.PAYMENT_OPTION && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.view_scheduled_transfer.payment_type", {
                    defaultValue: "Payment Type",
                  })}
                </label>
                <span>
                  {metaData.paymentTypes[formDetails?.paymentType] ||
                    formDetails?.paymentType}
                </span>
              </div>
            )}

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.no_of_instal", {
                    defaultValue: "Number of installment",
                  })}
                </label>
                <span>{formDetails?.numberOfInstallments || "-"}</span>
              </div>
            ) : null}

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.frequency", {
                    defaultValue: "Frequency",
                  })}
                </label>
                <span>{formDetails?.frequency}</span>
              </div>
            ) : null}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.common_sendMoney.date", {
                  defaultValue: "Date",
                })}
              </label>
              {paymentType === "ONCE" && paymentSubType === "Pay_Now" && (
                <span>{dayjs().format("DD-MM-YYYY")}</span>
              )}
              {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}

              {paymentType === "RECURRING" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}
            </div>

            {hasFxDeal ? (
              <>
                <div className="confirm-label-wrapper">
                  <label>
                    {t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                  </label>
                  <span>{formDetails?.fxDealRefNo}</span>
                </div>
              </>
            ) : null}

            <div className="confirm-label-wrapper">
              <label>
                {t("common.remarks", {
                  defaultValue: "Reason",
                })}
              </label>
              <span>{formDetails?.remarksTag || "-"}</span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          {/* <Button
            onClick={() => setCancelVisible(true)}
            type="default"
            style={{ marginRight: 30 }}
            className="secondary-btn"
            size="large"
          >
            {t("buttons.cancel_btn", {
              defaultValue: "Cancel",
            })}
          </Button> */}

          <Button
            onClick={() => setStage(1)}
            type="default"
            className="secondary-btn mx-3"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            onClick={() => fundTransferVerify()}
            type="primary"
            className="primary-btn"
            size="large"
          >
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
      <Breadcrumb separator=">">
        {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/transfer")}>
            {t("navigation.transfer", {
              defaultValue: "Transfers",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span onClick={() => navigate("/send-money/quick-pay")}>
            {t("pages.sendMoney.payee.quick_transfer", {
              defaultValue: "Quick Transfer",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {t("pages.Add_Bene.wallet", {
              defaultValue: "Wallet",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <div className="d-flex" style={{ height: "25px" }}>
              <p className="title title-header hide-xs">
                {t("pages.sendMoney.payee.quick_transfer", {
                  defaultValue: "Quick Transfer",
                })}{" "}
              </p>
              <p className="Pipe hide-xs">|</p>
              <p className="beneTitle">
                {t("pages.Add_Bene.wallet", {
                  defaultValue: "Wallet",
                })}
              </p>
            </div>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        {stage === 1 ? (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card">
              <AccountCard currencyFilter={true} />
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card">
              <AccountSelectedCard />
            </Card>
          </div>
        )}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card card-padding">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={t("pages.sendMoney.payee.quick_transfer", {
          defaultValue: "Cancel transfer?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.otp.quitCancelTitle", {
            defaultValue:
              " If you cancel this transaction now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            className="secondary-btn"
            type="default"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/transfer");
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{respDetails?.message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/transfer");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
            {mode === "AA" &&
              paymentType === "ONCE" &&
              paymentSubType === "Pay_Now" && (
                <>
                  <Button
                    size="large"
                    onClick={() => {
                      handleDownload(respDetails);
                    }}
                    className="secondary-btn mx-4"
                  >
                    {t("buttons.download_btn", { defaultValue: "Download" })}
                  </Button>
                </>
              )}
          </div>
        </div>
      </Modal>
    </>
  );
}
